import { useEffect, useState } from 'react';

import moment from 'moment';

import { getTimeDifference } from '@/utils';

export const useTimer = (originTime: Date, format = 'HH:mm:ss') => {
  const [duration, setDuration] = useState('');

  useEffect(() => {
    const tick = () => {
      setDuration(getTimeDifference(moment(), originTime).format(format));
    };
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);
  return { duration };
};
